import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

import {typesStoredcarddet} from '../svtypes/storedcarddet'


let headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export const svLoadStoredcarddetBegin = () => dispatch => {
    dispatch({
        type:'GET_STOREDCARDDET_BEGIN'
        
    })
}


export const geLoadStoredcarddetSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_STOREDCARDDET_SUCCESS',
        payload: data
    })
}

export const getLoadStoredcarddetError = (e) =>dispatch => {
    dispatch({
        type:'GET_STOREDCARDDET_ERROR',
        payload:e
    })
}





export function loadStoredcardDet(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadStoredcarddetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/storedcardDetail`
        const body = {
            "id": (nameQParam? nameQParam:3)
           }
          
        
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if( r.data ){
                    const ob = r.data
                    if(ob.cardId && (ob.cardId > 0)){
                        ob.id = ob.cardId;
                    }
                    const comData = { my_data_storedcarddet:  ob }
                    ob.cardNumber =ob.cardNumber? ob.cardNumber: ""
                    ob.cardCvv =ob.cardCvv? ob.cardCvv: ""
                    ob.cardExpMonth =ob.cardExpMonth? ob.cardExpMonth: ""
                    ob.cardExpYear =ob.cardExpYear? ob.cardExpYear: ""

                    ob.phone =ob.phone? ob.phone: ""
                    ob.email =ob.email? ob.email: ""
                    ob.name =ob.name? ob.name: ""
                    ob.fname =ob.fname? ob.fname: ""
                    ob.lname =ob.lname? ob.lname: ""
                    ob.address =ob.address? ob.address: ""
                    ob.zip =ob.zip? ob.zip: ""
                    ob.isdcode =ob.isdcode? ob.isdcode: ""

                    ob.city =ob.city? ob.city: ""
                    ob.state =ob.state? ob.state: ""
                   // ob.zip =ob.zip? ob.zip: ""
                    ob.id =ob.cardId? ob.cardId: "-1"

                    ob.country =ob.country? ob.country: ""

                    dispatch(geLoadStoredcarddetSuccess(comData))
                }
                else {
                    const comData = { my_data_storedcarddet: {
                        "id": -1,
    "cardId": -1,
    "customerId": 7,
    "paymentMethodCode": "card",
    "paymentType": "self",
    "productDetails": "svr",
    "description": "CHASE Card",
    "cardNumber": "4443412341234123",
    "cardCvv": "444",
    "cardExpMonth": "08",
    "cardExpYear": "22",
    "email": "alen@br.com",
    "isValid": "Y",
    "cardDelete": "N",
    "cardBlock": "N",
    "createdDate": "2024-08-13T04:00:00.000+0000",
    "modifiedDate": "2024-08-13T04:00:00.000+0000",
    "createdBy": "AbodeSystemAdmin",
    "modifiedBy": "AbodeSystemAdmin",
    "name": "",
    "fname": "",
    "lname": "",
    "phone": "",
    "address": "",
    "zip": "",
    "isdcode": "",
    "city": "",
    "state": "",
    "country": ""
                    }}
                    dispatch(getLoadStoredcarddetError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadStoredcarddetError(e))
        )
    }
}


export function loadStoredcardDetSecure_svj31(nameQParam, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadStoredcarddetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/storedcardDetailSecure`
        const authtoken = `Bearer ${svtv}`
           const svheaders = { 'Authorization': authtoken,
           'Content-Type': 'application/json' };
        const body = {
            "id": (nameQParam? nameQParam:3)
           }
          // body.id = 97
          
        
        axios.post(url, body, {headers:svheaders})
        .then(
            r => {
                if( r.data ){
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getLoadStoredcarddetError(eeb))
                    }else{
                        if(ob.cardId && (ob.cardId > 0)){
                            ob.id = ob.cardId;
                        }
                        const comData = { my_data_storedcarddet:  ob }
                        ob.cardNumber =ob.cardNumber? ob.cardNumber: ""
                        ob.cardCvv =ob.cardCvv? ob.cardCvv: ""
                        ob.cardExpMonth =ob.cardExpMonth? ob.cardExpMonth: ""
                        ob.cardExpYear =ob.cardExpYear? ob.cardExpYear: ""
    
                        ob.phone =ob.phone? ob.phone: ""
                        ob.email =ob.email? ob.email: ""
                        ob.name =ob.name? ob.name: ""
                        ob.fname =ob.fname? ob.fname: ""
                        ob.lname =ob.lname? ob.lname: ""
                        ob.address =ob.address? ob.address: ""
                        ob.zip =ob.zip? ob.zip: ""
                        ob.isdcode =ob.isdcode? ob.isdcode: ""
    
                        ob.city =ob.city? ob.city: ""
                        ob.state =ob.state? ob.state: ""
                       // ob.zip =ob.zip? ob.zip: ""
                        ob.id =ob.cardId? ob.cardId: "-1"
    
                        ob.country =ob.country? ob.country: ""
    
                        dispatch(geLoadStoredcarddetSuccess(comData))
                    }
                   
                }
                else {
                    const comData = { my_data_storedcarddet: {
                        "id": -1,
    "cardId": -1,
    "customerId": 7,
    "paymentMethodCode": "card",
    "paymentType": "self",
    "productDetails": "svr",
    "description": "CHASE Card",
    "cardNumber": "4443412341234123",
    "cardCvv": "444",
    "cardExpMonth": "08",
    "cardExpYear": "22",
    "email": "alen@br.com",
    "isValid": "Y",
    "cardDelete": "N",
    "cardBlock": "N",
    "createdDate": "2024-08-13T04:00:00.000+0000",
    "modifiedDate": "2024-08-13T04:00:00.000+0000",
    "createdBy": "AbodeSystemAdmin",
    "modifiedBy": "AbodeSystemAdmin",
    "name": "",
    "fname": "",
    "lname": "",
    "phone": "",
    "address": "",
    "zip": "",
    "isdcode": "",
    "city": "",
    "state": "",
    "country": ""
                    }}
                    dispatch(getLoadStoredcarddetError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadStoredcarddetError(e))
        )
    }
}


export function addStoredcardNowSecure(rqValues, svtv){
    
    console.log('%%%%%%%%%%%%%%%sv++++REST API For createOrModifyAddressNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svcreateOrModifyAddressBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createOrModifyCardFullNowSecure`

        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
           const svheaders = { 'Authorization': authtoken,
           'Content-Type': 'application/json' };
        axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {

                let comData = {
                    "my_data_storedcard_confirmation" : {

                        "status":"OK",
                        "cardId":-11,
                        "saveDate":"Jan 3027"
                    }
                }
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob

                if(r.data){
                   
                   
                    comData.my_data_storedcard_confirmation = r.data
                    

                   
                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
                else {
                    comData.my_data_storedcard_confirmation.status = "FAILED"
                    comData.my_data_storedcard_confirmation.cardId = -12
                    comData.my_data_storedcard_confirmation.saveDate = "Jan 3027"

                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCreateOrModifyAddressError(e))
        )
    }

}


export function addStoredcardNow(rqValues){
    
    console.log('%%%%%%%%%%%%%%%sv++++REST API For createOrModifyAddressNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svcreateOrModifyAddressBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createOrModifyCardFullNow`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_storedcard_confirmation" : {

                        "status":"OK",
                        "cardId":-11,
                        "saveDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_storedcard_confirmation = r.data
                    

                   
                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
                else {
                    comData.my_data_storedcard_confirmation.status = "FAILED"
                    comData.my_data_storedcard_confirmation.cardId = -12
                    comData.my_data_storedcard_confirmation.saveDate = "Jan 3027"

                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCreateOrModifyAddressError(e))
        )
    }

}




export const svcreateOrModifyAddressBegin = () => dispatch => {
    dispatch({
        type:typesStoredcarddet.GET_SAVESTOREDCARD_BEGIN
        
    })
} 


export const getCreateOrModifyAddressError = (e) =>dispatch => {
    dispatch({
        type:typesStoredcarddet.GET_SAVESTOREDCARD_ERROR,
        payload:e
    })
}


export const getCreateOrModifyAddressSuccess = (data) => dispatch => {
    dispatch({
        type: typesStoredcarddet.GET_SAVESTOREDCARD_SUCCESS,
        payload: data
    })
}


export const svLoadStoredcarddetReset = (data) => dispatch => {
   
    dispatch({
        type: "RESET_STOREDCARD_INIT",
        payload: data
    })
}

/*svj31 start*/

export function loadStoredcardDetSecure(nameQParam, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadStoredcarddetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/storedcardDetailSecure`
        const authtoken = `Bearer ${svtv}`
           const svheaders = { 'Authorization': authtoken,
           'Content-Type': 'application/json' };
        const body = {
            "id": (nameQParam? nameQParam:3)
           }
          // body.id = 97
          //svj15start
      const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
      const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}

        
      axios.all([
        axios.post(url, body, {headers:svheaders}),
        axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers}),
    ], {
        timeout: 7000
    }).then(
        axios.spread((r,r5)=>{

            //svj31 rstart
            if( r.data ){
                const ob = r.data
                if(ob.status && ob.status !=200){
                    let eeb = {

                    }
                    eeb.errob = ob
                    dispatch(getLoadStoredcarddetError(eeb))
                }else{
                    if(ob.cardId && (ob.cardId > 0)){
                        ob.id = ob.cardId;
                    }
                      //svr5 start
                      let my_data_geo = null
                      console.log('*******svj31 my_data_geo*********')
                      console.log(r5.data )
                      if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                       my_data_geo = r5.data
                      
                      }
                      
                      //svr5 end

                    const comData = { my_data_storedcarddet:  ob, my_data_geo:my_data_geo }
                    ob.cardNumber =ob.cardNumber? ob.cardNumber: ""
                    ob.cardCvv =ob.cardCvv? ob.cardCvv: ""
                    ob.cardExpMonth =ob.cardExpMonth? ob.cardExpMonth: ""
                    ob.cardExpYear =ob.cardExpYear? ob.cardExpYear: ""

                    ob.phone =ob.phone? ob.phone: ""
                    ob.email =ob.email? ob.email: ""
                    ob.name =ob.name? ob.name: ""
                    ob.fname =ob.fname? ob.fname: ""
                    ob.lname =ob.lname? ob.lname: ""
                    ob.address =ob.address? ob.address: ""
                    ob.zip =ob.zip? ob.zip: ""
                    ob.isdcode =ob.isdcode? ob.isdcode: ""

                    ob.city =ob.city? ob.city: ""
                    ob.state =ob.state? ob.state: ""
                   // ob.zip =ob.zip? ob.zip: ""
                    ob.id =ob.cardId? ob.cardId: "-1"

                    ob.country =ob.country? ob.country: ""
                    console.log(comData )
                    dispatch(geLoadStoredcarddetSuccess(comData))
                }
               
            }
            else {
                const comData = { my_data_storedcarddet: {
                    "id": -1,
"cardId": -1,
"customerId": 7,
"paymentMethodCode": "card",
"paymentType": "self",
"productDetails": "svr",
"description": "CHASE Card",
"cardNumber": "4443412341234123",
"cardCvv": "444",
"cardExpMonth": "08",
"cardExpYear": "22",
"email": "alen@br.com",
"isValid": "Y",
"cardDelete": "N",
"cardBlock": "N",
"createdDate": "2024-08-13T04:00:00.000+0000",
"modifiedDate": "2024-08-13T04:00:00.000+0000",
"createdBy": "AbodeSystemAdmin",
"modifiedBy": "AbodeSystemAdmin",
"name": "",
"fname": "",
"lname": "",
"phone": "",
"address": "",
"zip": "",
"isdcode": "",
"city": "",
"state": "",
"country": ""
                }}
                dispatch(getLoadStoredcarddetError(comData))
            }

            //svj31 rend

        })
          
        ).catch(
            e=>dispatch(getLoadStoredcarddetError(e))
        )
    }
}

export function createResetFlagsStoredcardDet(){
    console.log('%%%%%%%%%%%%%%%sv++++RESET createResetFlagsStoredcardDet For _doc swith sae key ')
    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********0')
                
    return dispatch =>{
        let my_data_geo = null
        let body = {"reset":"yes",my_data_geo:my_data_geo }
        //svstart
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
                    const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
     
        axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
        .then(
            r => {
                console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1a')
                   
                if( r.data ){
                    //svaiiisd_geoPost start
                    
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2a')
                    console.log(r.data )
                    if(  r.data.countryTypes && r.data.countryTypes.length>0){
                     my_data_geo = r.data
                     body.my_data_geo = my_data_geo
                    }
                    console.log(body )
                    //svaiiisd_geoPost end

                    dispatch(svLoadStoredcarddetReset(body))
                }else{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2b')
                   
                    dispatch(svLoadStoredcarddetReset(body))
                }
            }
        ).catch(
                e=>{
                    console.log('svj31 my_data_geo ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1b')
                   
                    dispatch(getCreateOrModifyAddressError(e))
                }
            )
        //svend
       
    }
}

/*svj31 end*/
